export default "__VITE_ASSET__B5l3ICBp__"